<template>
  <div class="container">
    <el-form :model="form" size="mini" inline ref="form">
      <el-form-item label="活动ID" prop="id">
        <el-input v-model="form.id" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="活动名称" prop="activity_name">
        <el-input v-model="form.activity_name" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="活动店铺" prop="shop_id">
        <el-select v-model="form.shop_id" filterable remote clearable placeholder="请选择">
          <el-option v-for="item in shops" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="活动状态" prop="status">
        <el-select
            v-model="form.status"
            clearable
            placeholder="请选择">
          <el-option v-for="(label, value) in statusMap" :key="value" :label="label" :value="value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="活动时间" prop="time">
        <el-date-picker
            v-model="form.time"
            type="daterange"
            clearable
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="loadData(true)">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="line"></div>
    <el-row class="pb20">
      <el-button type="primary" size="mini" @click="edit(null)">新增</el-button>
    </el-row>
    <el-table :data="data" v-loading="loading" border style="width: 100%">
      <el-table-column label="活动ID" prop="id" width="80"></el-table-column>
      <el-table-column label="活动名称" prop="activity_name" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column label="活动店铺" prop="shop_name" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column label="活动简介" prop="brief" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column label="活动开始时间" prop="begin_time" width="160"></el-table-column>
      <el-table-column label="活动结束时间" prop="end_time" width="160"></el-table-column>
      <el-table-column label="报名情况" prop="sign" width="120">
        <template slot-scope="{row}">
          <div>{{ row.join_num }} / {{ row.number }}</div>
        </template>
      </el-table-column>
      <el-table-column label="签到情况" prop="check" width="120">
        <template slot-scope="{row}">
          <div>-</div>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="statusTip" width="80" fixed="right"></el-table-column>
      <el-table-column label="上线" prop="online" width="80" fixed="right">
        <template slot-scope="{row, rowIndex}">
          <el-switch :value="!!(row.activity_status)" @change="onShelfActivity(row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="{row}">
          <el-link type="primary" :underline="false" @click="detail(row)">查看</el-link>
          <el-link type="primary" :underline="false" @click="edit(row)" v-if="row.status == 0">编辑</el-link>
          <el-link type="primary" :underline="false" @click="joinDetail(row)">报名详情</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="form.page"
        :page-size="form.pageSize"
        :page-sizes="pageSizes"
        prev-text="上一页"
        next-text="下一页"
        layout="prev, next">
    </el-pagination>
  </div>
</template>

<script>
import activityForm from "./activityForm.vue";
import activityDetail from "./activityDetail.vue";
// 0-未开始 1-进行中 2-已结束
const statusMap = {
  0: '未开始',
  1: '进行中',
  2: '已结束'
}
export default {
  name: "activityList",
  components: {activityForm, activityDetail},
  data() {
    return {
      loading: false,
      data: [],
      detailLoading: false,
      detailData: [{}],
      form: {
        page: 1,
        pageSize: 20,
        id: '',
        shop_id: undefined,
        school_id: this.$store.getters.schoolId,
        activity_name: '',
        status: '',
        begin_time: '',
        end_time: '',
        time: []
      },
      pageSizes: [10, 20, 30, 40, 50],
      statusMap,
      shops: [],
    }
  },
  created() {
    this.loadData(true);
    try {
      this.shops = JSON.parse(localStorage.getItem('shops'));
    } catch (e) {
      this.shops = [];
    }
  },
  methods: {
    loadData(reload = false) {
      if (this.loading) return;
      if (reload) {
        this.form.page = 1;
      }
      this.loading = true;
      this.$api.get_glue(this.$apiUrl.getActivityList, {
        ...this.form,
        begin_time: this.form.time && this.form.time[0] ? this.form.time[0] : '',
        end_time: this.form.time && this.form.time[1] ? this.form.time[1] : '',
        time: undefined
      }, (res) => {
        this.loading = false;
        if (res.data) {
          this.data = res.data.list || [];
        } else {
          this.data = [];
        }
      }, (res) => {
        this.loading = false;
        this.data = [];
      });
    },
    reset() {
      this.$refs.form.resetFields();
    },
    edit(row) {
      this.$router.push({
        path: `/activity/edit/${this.$route.params.ruleId}`,
        query: {
          id: row && row.id ? row.id : undefined
        }
      })
    },
    detail(row) {
      this.$router.push({
        path: `/activity/detail/${this.$route.params.ruleId}`,
        query: {
          id: row.id
        }
      })
    },
    joinDetail(row) {
      this.$router.push({
        path: `/activity/join/${this.$route.params.ruleId}`,
        query: {
          id: row.id
        }
      })
    },
    handleSizeChange(val) {
      this.form.pageSize = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.loadData();
    },
    onShelfActivity(row) {
      this.$confirm(`确认${row.activity_status == 1 ? '下' : '上'}架该活动吗？`, '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认'
      }).then(() => {
        let activity_status = row.activity_status == 1 ? 0 : 1
        this.$api.post_glue(this.$apiUrl.shelfActivity, {
          id: row.id,
          activity_status,
          user_id: this.$store.getters.userId
        }, res => {
          if (res.result) {
            this.$message.success('提交成功');
            row.activity_status = activity_status;
          } else {
            this.$message.error(res.message);
          }
        }, res => {
          this.$message.error(res.message);
        })
      }).catch(() => {

      })
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// list.vue?2867d4c1